import React from "react"
import "./DisplayDataContainer.scss"
import {useDispatch, useSelector} from "react-redux"
import LoadingOverlay from "react-loading-overlay"
import {Wave} from "react-css-spinners"
import DisplayDataConfigBar from "./DisplayDataConfigBar/DisplayDataConfigBar"

import {isExporting, isLoadingDisplayData} from "../redux/refdb.selector"
import DisplayDataConfigBarInternal from "./DisplayDataConfigBar/DisplayDataConfigBarInternal"
import {showDisclaimer, userRoles} from "../../core/selectors/core.selector"
import DisplayDisclaimerPanel from "./DisplayDisclaimerPanel"
import {getShowDisclaimerAction} from "../../core/actions/core.actions"
import InvalidLicense from "../../@biocrates-common-repo/pages/invalidLicense/InvalidLicense"
import licenceService from "./LicenceService"
import useComponentWillMount from "../../core/utils/componentUtils"
import {loadTotalNumberOfSamplesAction} from "../redux/refdb.actions"
import EulaAcceptanceRequired from "../../@biocrates-common-repo/pages/EulaAcceptanceRequired/EulaAcceptanceRequired"
import RefDbPanel from "./RefDbPanel"

const RefDbContainer = (): JSX.Element => {
    const dispatch = useDispatch()

    const isLoading = useSelector(isLoadingDisplayData)
    const isExportingData = useSelector(isExporting)

    const roles = useSelector(userRoles)
    const disclaimer = useSelector(showDisclaimer)

    const isWithOutLicence = (): boolean => {
        return licenceService.isWithOutLicence(roles)
    }

    const isEulaAccepted = (): boolean => {
        return licenceService.isEulaAccepted(roles)
    }

    const isCustomer = (): boolean => {
        return licenceService.isCustomer(roles)
    }

    // User could have both licences:internal and external. External license overrules the internal license.
    const isOnlyInternal = (): boolean => {
        return licenceService.isOnlyInternal(roles)
    }

    useComponentWillMount(() => {
        if (isCustomer()) {
            dispatch(loadTotalNumberOfSamplesAction())
            dispatch(getShowDisclaimerAction())
        }
    })

    return (
        <div className="DisplayDataContainer">
            {isWithOutLicence() && <InvalidLicense />}
            {!isWithOutLicence() && !isEulaAccepted() && (
                <EulaAcceptanceRequired />
            )}
            {isOnlyInternal() && <DisplayDataConfigBarInternal />}
            {isCustomer() && disclaimer === false && <DisplayDataConfigBar />}
            {isCustomer() && disclaimer === true && <DisplayDisclaimerPanel />}
            <LoadingOverlay
                className="DisplayDataTable"
                active={isLoading || isExportingData}
                spinner={<Wave color="#00425A" />}
                fadeSpeed={100}
                styles={{
                    overlay: (base) => ({
                        ...base,
                        background: "rgba(238, 240, 242, 0.5)",
                        zIndex: "15",
                    }),
                }}
            >
                <RefDbPanel />
            </LoadingOverlay>
        </div>
    )
}

export default RefDbContainer
